import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import useMantineMediaQueries from "@hl/base-components/lib/hooks/useMantineMediaQueries";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Group, Select, Text } from "@mantine/core";
import { DatePicker, TimeInput } from "@mantine/dates";
import dayjs, { extend, unix } from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
extend(timezone);
extend(advancedFormat);
extend(customParseFormat);
const ExpirationOptionSelect = ({ expirationOptions, expirationOption, setExpirationOption, label, compact, }) => {
    const now = new Date();
    const isCustom = useMemo(() => expirationOption.value === "custom", [expirationOption.value]);
    const monthFromNow = dayjs(now).add(30, "days").toDate();
    const [date, setDate] = useState(isCustom && expirationOption.relativeTime
        ? unix(expirationOption.relativeTime).toDate()
        : monthFromNow);
    const { isMobile } = useMantineMediaQueries({ withInitialValues: true });
    const checkValidityAndSetTime = (d, t) => {
        const defaultDate = dayjs().add(1, "minute").toDate();
        if (!d || !t) {
            return setDate(defaultDate);
        }
        const minute = d.getMinutes();
        const hour = d.getHours();
        const newDateTime = dayjs(t).minute(minute).hour(hour);
        if (newDateTime.unix() < dayjs().unix()) {
            setDate(defaultDate);
        }
        else {
            setDate(newDateTime.toDate());
        }
    };
    useEffect(() => {
        if (!date || !isCustom) {
            return;
        }
        const relativeTime = dayjs(date).unix();
        if (relativeTime !== expirationOption.relativeTime) {
            setExpirationOption({ ...expirationOption, relativeTime });
        }
    }, [date, expirationOption, isCustom]);
    const isDesktopCompact = compact && !isMobile;
    return (_jsxs(Group, { align: "flex-end", spacing: "md", w: "100%", noWrap: isDesktopCompact, children: [_jsx(Select, { withinPortal: true, styles: {
                    root: {
                        flexGrow: isDesktopCompact ? 0 : 1,
                        width: compact && !isMobile ? 120 : "100%",
                    },
                    input: {
                        marginTop: compact ? (isMobile ? 8 : 0) : 16,
                    },
                }, label: label, placeholder: `Pick the ${(label === null || label === void 0 ? void 0 : label.toLowerCase()) || "expiration option"}`, data: expirationOptions.map((el) => ({
                    label: el.text,
                    value: el.value,
                })), value: expirationOption.value, onChange: (value) => {
                    const selectedOption = expirationOptions.find((eo) => eo.value === value);
                    setExpirationOption(selectedOption);
                } }), isCustom && (_jsxs(_Fragment, { children: [_jsx(DatePicker, { placeholder: "Pick date", value: date, onChange: (d) => checkValidityAndSetTime(date, d), minDate: new Date(), withinPortal: true, styles: {
                            root: {
                                // @ts-ignore
                                flexGrow: isDesktopCompact ? "0 !important" : "1 !important",
                            },
                            calendarBase: {
                                maxWidth: "unset",
                            },
                            input: {
                                marginTop: compact ? "0px !important" : undefined,
                            },
                        }, clearable: false }), _jsx(TimeInput, { styles: {
                            root: {
                                flexGrow: isDesktopCompact ? 0 : 1,
                            },
                            input: {
                                padding: "0 60px 0 16px",
                                display: "flex",
                                alignItems: "center",
                                marginTop: compact ? "0px !important" : undefined,
                            },
                            rightSection: {
                                justifyContent: "flex-end",
                                paddingRight: 10,
                            },
                        }, rightSection: _jsx(Text, { size: "sm", color: TEXT_COLOR.SECONDARY, children: dayjs().format("z") }), sx: { marginTop: 0 }, rightSectionWidth: 100, format: "12", value: date, onChange: (d) => checkValidityAndSetTime(d, date) })] }))] }));
};
export default ExpirationOptionSelect;
